import styled from "styled-components";
import Dialog from "material-ui/Dialog";

export const ImportExportModal = styled(Dialog)`
   .import-export__modal {
    overflow-y: auto !important; 
    box-sizing: content-box !important;
  }
`;

export const StyledImportExport = styled.div`
  .content {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    justify-content: space-around;
    height: auto; 
    min-height: 24vh;
    max-height: 40vh;
    overflow-y: auto !important;
    padding-left: 7px;
    padding-right: 7px;

    &.error-state {
      height: auto;
      max-height: 40vh;
      overflow-y: auto; 

      ::-webkit-scrollbar {
        height: 6px;
      }

      ::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
      }
    }

    .title {
      width: 95%;
      text-align: center;
      margin-top: 20px;
    }

    .last-title {
      margin-bottom: 20px;
    }
  }

  .button-download-content {
    margin-bottom: 1rem;
  }

  .button-download {
    width: 140px;
  }

  .button-footer {
    width: 80px;
  }

  .content-footer {
    margin-top: 7px;
    display: flex;
    justify-content: space-between;
  }

  .footer-right {
    display: flex;
    justify-content: align-items;
  }

  .btn-dowload-logs {
    width: 80%;
  }

  .btn-next {
    margin-left: 10px;
  }

  .results-list {
    width: 100%;
  }

  .messages-list {
    max-height: 170px;
    overflow-y: auto;
  }

  .messages-items {
    width: 100%;
  }

  .rowListHeader {
    color: var(--color-contrast-black);
    font-weight: var(--font-weight-semibold);
    padding: 5px 0 7px 0;
    border-bottom: 1px dashed var(--color-neutral-300);
    padding-left: 4px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
  }

  .rowList {
    background: var(--color-contrast-white);
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 4px;
    border-bottom: 1px dashed var(--color-neutral-300);

    &:hover {
      background: #f4f5f8;
    }
  }

  .green {
    box-shadow: inset 4px 0 #81aa4c;

    &:hover {
      box-shadow: inset 4px 0 #81aa4c;
    }
  }

  .yellow {
    box-shadow: inset 4px 0 #e8b007;

    &:hover {
      box-shadow: inset 4px 0 #e8b007;
    }
  }

  .red {
    box-shadow: inset 4px 0 #ec393d;

    &:hover {
      box-shadow: inset 4px 0 #ec393d;
    }
  }

  .link {
    width: auto !important;
    color: var(--color-action-default);
    cursor: pointer;
  }

  .link:hover {
    cursor: pointer;
  }
  .errors-content {
    width: 570px;
    height: auto;
    background-color: #faebd7;
    margin-bottom: 15px;
    border-radius: 10px;
    padding: 0px 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column; 
  }
  
`;